import { connect } from 'react-redux';
import { redirect } from 'redux-first-router';
import ContentPage from '../components/pages/ContentPage';
import {ROUTES} from '../constants';

const mapStateToProps = ({ page,auth }) => ({ page,auth });
const mapDispatchToProps = (dispatch) => {
	return {
		redirectToLandingPage : () =>{
			dispatch((dispatch)=>{
				const action = redirect({type:ROUTES.LANDING_PAGE});
				dispatch(action);
			});
		},
	};
};
export default connect(mapStateToProps,mapDispatchToProps)(ContentPage);